import axios from 'axios';
import app from '../main'


// 创建 axios 实例
const http = axios.create({
    baseURL: process.env.VUE_APP_API_HOST + '/api/union/', 
    timeout: 30000 // 请求超时时间
})

// 错误处理函数
const err = (error) => {
    if (error.response) {
        const data = error.response.data
        app.$message.error(data.msg || '网络异常，请重试');
    }
    return Promise.reject(error)
}

// request interceptor(请求拦截器)
http.interceptors.request.use(config => {
    const token = app.$helper.getStorage('union-auth-token');
    config.headers['auth-token'] = token || '';
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    return config
}, err)

// response interceptor（接收拦截器）
http.interceptors.response.use((response) => {
    const res = response.data
    if (res.ret !== 0) { 
        
        app.$message.error(res.msg || '系统异常');

        if (res.ret === 403) {
            // 401:需要重新登录;
            app.$helper.setStorage('union-auth-info',{});
            app.$helper.setStorage('union-auth-token','');
            app.$store.dispatch('initAuthInfo');
            app.$router.push('/')
        }

        return Promise.reject(res)
    } else {
        return res
    }
}, err)

export default http;